import * as t from "io-ts";
import { decode } from "io-ts-promise";
import {
  createEquipmentTypes,
  equipmentActiveRentalsT,
  equipmentJobResultT,
} from "dora-contracts";

const { baseEquipmentT, equipmentT, equipmentsT, updateEquipmentT } =
  createEquipmentTypes({
    decimal: t.string,
  });

export type UpdateEquipment = t.TypeOf<typeof updateEquipmentT>;
export type Equipment = t.TypeOf<typeof equipmentT>;
export type BaseEquipment = t.TypeOf<typeof baseEquipmentT>;
export const decodeEquipments = decode(equipmentsT);
export const decodeEquipment = decode(equipmentT);
export const decodeEquipmentActiveRentals = decode(equipmentActiveRentalsT);

// POST /api/equipment/:id/jobs: create a "Tøm" (EMPTY) or "Retur" (END_RENTAL)
// transport order for a unit that is with a customer.
export type {
  EquipmentJobKind,
  EquipmentJobResult,
  CreateEquipmentJob,
} from "dora-contracts";
export const decodeEquipmentJobResult = decode(equipmentJobResultT);
